module.exports = __webpack_public_path__ + "static/media/lock.7dd433a1.svg";